!((document, Drupal) => {
  'use strict';

  /**
   * Language selector JS
   */
  Drupal.behaviors.languageSelector = {
    attach: (context) => {
      once('languageSelector', '.js-language-selector-btn',
        context).
        forEach(langToggleBtn => {
          const languageSelectorList = document.querySelector(
            '.js-language-selector-list');

          langToggleBtn.addEventListener('click', () => {
            if (langToggleBtn.classList.contains('on')) {
              langToggleBtn.classList.remove('on');
              langToggleBtn.classList.add('off');

              languageSelectorList.classList.remove('open');
              languageSelectorList.classList.add('close');
            }
            else {
              langToggleBtn.classList.remove('off');
              langToggleBtn.classList.add('on');

              languageSelectorList.classList.remove('close');
              languageSelectorList.classList.add('open');
            }
          });
        });
    },
  };

})(document, Drupal);
